import { TICKER_ITEMS } from "@/mocks/content";

export default function Ticker() {
  const doubled = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="relative z-10 flex items-center border-y border-accent-200/40 bg-accent-500 text-accent-950">
      <div className="flex shrink-0 items-center gap-2 bg-foreground-950 px-4 py-2.5 text-foreground-100 md:px-5">
        <span className="flex h-2 w-2 items-center justify-center">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
          </span>
        </span>
        <span className="whitespace-nowrap text-xs font-bold tracking-widest md:text-sm">现场快讯</span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-marquee gap-10 py-2.5 pl-6">
          {doubled.map((item, i) => (
            <span
              key={i}
              className="flex items-center gap-3 whitespace-nowrap text-sm font-medium text-accent-950"
            >
              <i className="ri-sparkling-line text-accent-900"></i>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}